export default {
  // Settings
  "settings": "설정",
  "profile": "프로필",
  "security": "보안",
  "theme": "테마",
  "feedback": "피드백",
  "data": "데이터",
  "appearance_settings": "모양 설정",
  "select_theme": "선호하는 테마 선택",
  "light": "밝은 테마",
  "dark": "어두운 테마",
  "system": "시스템",
  "language_changed": "언어가 다음으로 변경되었습니다:",
  "failed_update_language": "언어 업데이트 실패",
  "profile_settings": "프로필 설정",
  "username_cannot_change": "사용자 이름을 변경할 수 없는 기간:",
  "more_days": "일 더 남음",
  "email_cannot_change": "이메일은 변경할 수 없습니다",
  "profile_links": "프로필 링크",
  "link_one": "링크 1",
  "link_two": "링크 2",
  "password_change": "비밀번호 변경",
  "current_password": "현재 비밀번호",
  "new_password": "새 비밀번호",
  "confirm_password": "비밀번호 확인",
  "update_password": "비밀번호 업데이트",
  "password_must_be": "비밀번호는 8자에서 25자 사이여야 합니다",
  "security_questions": "보안 질문",
  "security_question": "보안 질문",
  "update_security_questions": "보안 질문 업데이트",
  "setup_security_questions": "보안 질문 설정",
  "select_question": "질문 선택",
  "your_answer": "답변",
  "enter_your_answer": "답변을 입력하세요",
  "submit_feedback": "피드백 제출",
  "feedback_type": "피드백 유형",
  "general_feedback": "일반 피드백",
  "bug_report": "버그 신고",
  "feature_request": "기능 요청",
  "airport_request": "새 공항 요청",
  "airport_iata": "공항 IATA 코드",
  "airport_name": "공항 이름",
  "airport_location": "공항 위치",
  "your_feedback": "피드백 내용",
  "data_management": "데이터 관리",
  "delete_all_films": "모든 필름 삭제",
  "delete_films_warning": "이 작업은 인벤토리에서 모든 필름을 영구적으로 삭제합니다. 이 작업은 취소할 수 없습니다.",
  "delete_all_reviews": "모든 리뷰 삭제",
  "delete_reviews_warning": "이 작업은 모든 리뷰를 영구적으로 삭제합니다. 이 작업은 취소할 수 없습니다.",
  "delete_account": "계정 삭제",
  "delete_account_warning": "경고: 이 작업은 취소할 수 없습니다. 계정과 모든 데이터가 서버에서 영구적으로 삭제됩니다.",
  "account_deleted_success": "계정이 성공적으로 삭제되었습니다",
  "account_deletion_failed": "계정 삭제 실패",
  "reviews_deleted_success": "모든 리뷰가 성공적으로 삭제되었습니다",
  "reviews_deletion_failed": "리뷰 삭제 실패",
  "films_deleted_success": "모든 필름이 성공적으로 삭제되었습니다",
  "films_deletion_failed": "필름 삭제 실패",
  "confirm_delete_films": "모든 필름을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  "confirm_delete_reviews": "모든 리뷰를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  "confirm_delete_account": "계정을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  "create_username": "사용자 이름 만들기",
  "username_required_description": "계정에 사용할 사용자 이름을 만드세요. 사용자 이름은 고유해야 하며 문자, 숫자 및 밑줄을 포함할 수 있습니다.",
  "username": "사용자 이름",
  "username_placeholder": "사용자 이름 입력",
  "username_requirements": "사용자 이름은 4~25자로, 문자, 숫자, 밑줄만 포함할 수 있습니다.",
  "save_username": "사용자 이름 저장",
  "username_taken": "이 사용자 이름은 이미 사용 중입니다",
  "username_set_success": "사용자 이름이 성공적으로 설정되었습니다",
  "username_set_error": "사용자 이름 설정 실패"
};
